import { Card, CardActionArea, CardContent, CardMedia, CardActions } from "@mui/material";


/**
 * Renders a card component for displaying a fretboard diagram.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.drawing - The drawing object containing the SVG data.
 * @param {number} props.index - The index of the card.
 * @param {number} props.position - The position of the selected card.
 * @param {Object} props.diagramCardStyle - The style object for the card.
 * @param {Object} props.diagramCardContentStyle - The style object for the card content.
 * @param {Function} props.handleCardClick - The callback function for handling card click events.
 * @returns {JSX.Element} The JSX element representing the fretboard card.
 */
function FretboardCard({ drawing, index, position, diagramCardStyle, diagramCardContentStyle, handleCardClick }) {
    return (
        <Card key={index} sx={index === position ? { ...diagramCardStyle, backgroundColor: "rgba(78, 156, 237, 0.3)" } : diagramCardStyle}>
            <CardActionArea onClick={() => handleCardClick(drawing, index)} >
                <CardContent sx={diagramCardContentStyle}>
                    <CardMedia component="img" image={`data:image/svg+xml;base64,${btoa(drawing.svg)}`} sx={{ width: "100%" }} />
                </CardContent>
            </CardActionArea>
            <CardActions disableSpacing>

            </CardActions>
        </Card>
    );
}

export default FretboardCard;
